const base = require("./base");
const slickCarousel = require("../components/initSlickSlider");
const {setBadgeColors} = require("coremh/product/producttile");
const debounce = require("lodash/debounce");
const formHelpers = require("coremh/components/formErrors");
const recaptcha = require("google/recaptcha");
const { setCSRFToken } = require("coremh/components/utils");
const { updateBottomBackToTop } = require("coremh/components/backToTop");
var productsFormat = [];
var productsPackaging = [];
var config = { childList: true, subtree: false};
var $document = $("document");
const $body = $("body");
const formReset = require("coremh/components/formReset");
let isKeyboardUser = false;


/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */


function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $("button.add-to-cart-global").attr("disabled", enableOrDisable);
}
$(document).ready(function () {
    $(".select2-container").on("click", function () {
        $(".select2-results__options li").each(function() {
            $(this).mouseout(function() {
                $(this).removeClass("select2-results__option--highlighted").attr("aria-selected", "false");
            });
        });
    });
    $("#packagingid").val($(".custom-select-format").find(":selected").data("id"));
    $("option.package-none-option").wrap("<span>");
    initProductsList();
    packagingPDP();
});
$(".custom-select-format").change(function () {
    window.location.href = $(this).val();
});
$(".custom-select-packaging").change(function () {
    var open = $(this).val();
    if (open) {
        window.location.href = $(this).val();
    }
});

function packagingPDP() {
    var istotalVolumeProductValueList = [];
    $(".custom-select-format > option").each(function () {
        istotalVolumeProductValueList.push($(this).attr("data-total-volume"));
    });
    let uniqueTotalVolumeProductValueList = Array.from(new Set(istotalVolumeProductValueList));
    var productsFormatList = [];
    $(".custom-select-format > option").each(function () {
        var isTotalVolume = $(this).data("total-volume");
        var isProductID = $(this).data("pid");
        uniqueTotalVolumeProductValueList.forEach(function (item) {
            if (Number(isTotalVolume) == Number(item)) {
                productsFormatList.push(isProductID);
            }
        });
    });
    var $currentProduct = $("#currentProductId");
    var currentProductId = $currentProduct.val();
    var currentTotalVolume = $(`.custom-select-format > option[data-pid=${currentProductId}]`).data("total-volume");

    let hashmap = new Map();
    let hashmapProductsFormat = new Map();
    $(".custom-select-format > option").each(function () {
        const $this = $(this);
        const pid = $this.data("pid");
        const totalVolume = $this.data("total-volume");
        const bottleVolume = $this.data("bottle-volume");
        const isSameVolumeAndProduct = currentProductId === String(pid) && currentTotalVolume === totalVolume;
        const isDifferentVolume = currentTotalVolume !== totalVolume;

        if (productsFormatList.includes(pid)) {
            if (hashmap.has(totalVolume)) {
                if (!hashmap.get(totalVolume).includes(bottleVolume)) {
                    hashmap.get(totalVolume).push(bottleVolume);
                    hashmapProductsFormat.get(totalVolume).push(pid);
                }
            } else if (isSameVolumeAndProduct || isDifferentVolume) {
                hashmap.set(totalVolume, []);
                hashmapProductsFormat.set(totalVolume, []);
                hashmap.get(totalVolume).push(bottleVolume);
                hashmapProductsFormat.get(totalVolume).push(pid);
            }
        }
    });
    var chosenProductList = [];
    for (let val of hashmapProductsFormat.values()) {
        for (let value of val) {
            chosenProductList.push(value);
        }
    }
    var isTotalVolumeList = [];
    var isBottleVolumeList = [];
    $(".custom-select-format > option").each(function () {
        if (String($(this).data("pid")) == currentProductId && $(this).data("total-volume") == $(this).data("bottle-volume")) {
            isTotalVolumeList.push($(this).data("total-volume"));
            isBottleVolumeList.push($(this).data("bottle-volume"));
        }
    });
    $(".custom-select-format > option").each(function () {
        if (!chosenProductList.includes($(this).data("pid"))) {
            $(this).attr("disabled", true);
        }
    });

    // Only last selected option remains
    if ($(".custom-select-format > option[selected]").length > 1) {
        $(".custom-select-format > option[selected]")[0].remove();
    }

    // We should not have duplicated PIDs in the format list
    var existsPIDs = {};
    $(".custom-select-format > option").each(function () {
        var pid = $(this).attr("data-pid");
        if (pid && existsPIDs[pid]) {
            existsPIDs[pid].elem.remove();
        } else {
            existsPIDs[pid] = {
                elem: $(this)
            };
        }
    });

    // Show Cheapest product in the format list (ex : if we have naked and with case, we show naked "the cheapest one")
    $(".custom-select-format > option:not([selected])").each(function () {
        var $this = $(this);
        var totalVolume = $this.data("total-volume");
        var bottleVolume = $this.data("bottle-volume");
        var pid = $this.data("pid");

        var $similarProduct = $(".custom-select-format > option[data-bottle-volume='" + totalVolume + "'][data-total-volume='" + bottleVolume + "']:not([data-pid='" + pid + "']):not([selected])");
        if ($similarProduct.length) {
            var price = parseFloat($this.data("price") || 0);
            var similarProductPrice = parseFloat($similarProduct.data("price") || 0);

            $this.attr("disabled", price > similarProductPrice);
            $similarProduct.attr("disabled", !(price > similarProductPrice));
        }
    });

    var getSelectedProductTotalVolumeValue = $(".custom-select-format").find(":selected").data("total-volume");
    var getSelectedProductBottleVolumeValue = $(".custom-select-format").find(":selected").data("bottle-volume");
    var isPackagingList = [];
    $(".custom-select-packaging > option").each(function () {
        if ($(this).data("total-volume") !== getSelectedProductTotalVolumeValue || $(this).data("bottle-volume") !== getSelectedProductBottleVolumeValue || $(this).data("ruinart-is-packaging") !== true) {
            $(this).remove();
        } else {
            isPackagingList.push($(this).data("pid"));
        }
    });
    if (!isPackagingList.includes(Number(currentProductId))) {
        $("#packaging-1").select2("destroy").remove();
        $("#packaging-1-label").remove();
    } else if (isPackagingList.length === 0) {
        $(".custom-select-packaging").addClass("emptySelectPackaging");
        $("option.package-none-option").unwrap();
        $(".custom-select-packaging").prop("disabled", true);
        $("#packaging-1").select2("destroy").remove();
        $("#packaging-1-label").remove();
    } else if (isPackagingList.length === 1) {
        $(".custom-select-packaging").addClass("emptySelectPackaging");
    }
    // add format none
    var isNoneProducts = [];
    if (isPackagingList.length !== 0) {
        $(".custom-select-packaging > option").each(function () {
            isNoneProducts.push($(this).data("id"));
        });
    }
    // swap two elements in a dropdown list
    $.fn.swap = function (elem) {
        if (elem) {
            var before = elem.prev();
            this.after(elem);
            before.after(this);
        }
    };
    var firstIndex;
    $(".custom-select-packaging > option").each(function () {
        if (this.index === 0) {
            firstIndex = $(this);
        }
        if (String($(this).data("id")).indexOf("naked") != -1) {
            if (this.index !== 0) {
                $(this).swap(firstIndex);
            }
        }
    });
}
function initFormatAndPackagingLists($this) {
    productsFormat.push({
        "bottlevolume" : $this.data("bottle-volume"),
        "id" : $this.data("id"),
        "pid" : $this.data("pid"),
        "ruinartispackaging" : $this.data("ruinart-is-packaging"),
        "totalvolume" : $this.data("total-volume"),
        "attrvalue" : $this.data("attr-value"),
        "url" : $this.val()
    });
    Object.assign(productsPackaging, productsFormat);
}
function initProductsList() {
    $(".custom-select-format > option").each(function () {
        initFormatAndPackagingLists($(this));
    });
}

/**
* Preloads images
*/
function preloadImages() {
    $("[data-srcset]").each(function () {
        $(this).attr("srcset", $(this).data("srcset"));
    });
}

/**
* Sets the tabindex attribute for all interactive button elements within a given element,
* and optionally focuses the first button if tabindex is set to 0.
*
* @param {jQuery} elem - The jQuery element containing the target buttons.
* @param {number} tabIndex - The tabindex value to assign to the buttons. If 0, the first button is focused.
*/
function setTabIndex(elem, tabIndex) {
    let $interActiveElem = elem.find("button:not([disabled]):not(.d-none):not(.disabled)");

    $interActiveElem.attr("tabindex", tabIndex);

    if (tabIndex === 0 && $interActiveElem.length) {
        let $firstActiveElem = $interActiveElem.first();

        if (isKeyboardUser) {
            $firstActiveElem.focus();
        } else {
            $firstActiveElem.blur();
        }
    }
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $("body").on("product:statusUpdate", function (e, data) {
            var $productContainer = $(".product-detail[data-pid='" + data.id + "']");

            $productContainer.find(".description-and-detail .product-attributes")
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find(".description-and-detail .description")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .description .content")
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find(".description-and-detail .description")
                    .addClass("hidden-xl-down");
            }

            if (data.longDescription) {
                $productContainer.find(".description-and-detail .details")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .details .content")
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find(".description-and-detail .details")
                    .addClass("hidden-xl-down");
            }
        });
    },

    showSpinner: function () {
        $("body").on("product:beforeAddToCart product:beforeAttributeSelect", function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            var $container = response.container;
            var $dataPersonalizationModal = $container.find("[data-target-personalization-modal]");

            if ($(".product-detail>.bundle-items").length || $(".product-set-detail").eq(0).length) {
                $container.data("pid", response.data.product.id);
                $container.find(".product-id").text(response.data.product.id);

                if ($dataPersonalizationModal.length) {
                    $dataPersonalizationModal.toggleClass("d-none", (!response.data.product.readyToOrder || !response.data.product.available || !response.data.product.personalization.isPersonalisable))
                        .data("action-url", $dataPersonalizationModal.data("action-url").replace(/pid=.+/, "pid=" + response.data.product.id));
                }
            } else if (response.data.product) {
                $(".product-id").text(response.data.product.id);
                $(".product-detail:not('.bundle-item')").data("pid", response.data.product.id);

                if ($dataPersonalizationModal.length) {
                    $dataPersonalizationModal.toggleClass("d-none", (!response.data.product.readyToOrder || !response.data.product.available || !response.data.product.personalization.isPersonalisable))
                        .data("action-url", $dataPersonalizationModal.data("action-url").replace(/pid=.+/, "pid=" + response.data.product.id));
                }
            }

            $container.find(".add-to-cart").data("product-ismandatorypersonalizable", response.data.product.personalization.isCustoMandatory);
            var $tagBadgeContainer = $container.find(".product-tagbadge");
            var $productBottleTypeContainer = $container.find(".product-type-bottle");
            var $addToCartBtn = $container.find(".add-to-cart");
            var $outOfStockBtn = $container.find(".btn-out-of-stock");
            var $availabilityMsgs = $container.find(".avalability-messages");
            var $productName = $container.find(".product-name");

            var currentProduct = response.data.product;
            var availabilityInfo = currentProduct.availabilityInfo;
            var productName = currentProduct.productName || "";
            var productBottleType = currentProduct.productBottleType || "";
            var isForcedOutOfStock = availabilityInfo.isForcedOutOfStock || false;
            var tagBadge = currentProduct.tagBadge || "";
            var primaryImageUrls = currentProduct.images.large || "";
            var updateImgCarousel = response.data.updateImgCarousel || false;
            var readyToOrder = currentProduct.readyToOrder || false;
            var available = currentProduct.available || false;
            var isInStock = availabilityInfo.isInStock;

            var limitedStockMessage = availabilityInfo.messages && availabilityInfo.messages.length ? availabilityInfo.messages[0] : null;
            $availabilityMsgs.empty();
            if (limitedStockMessage) {
                $availabilityMsgs.html(limitedStockMessage);
            } else {
                $availabilityMsgs.remove();
            }

            if (tagBadge) {
                $tagBadgeContainer
                    .empty()
                    .append(`<span class="tag-badge">${tagBadge}</span>`);
                setBadgeColors();
            } else {
                $tagBadgeContainer
                    .empty();
            }

            if (productBottleType) {
                $productBottleTypeContainer
                    .empty()
                    .html(productBottleType);
            } else {
                $productBottleTypeContainer
                    .empty();
            }

            if (isForcedOutOfStock || !readyToOrder || !available || !isInStock) {
                $addToCartBtn.addClass("d-none");
                $outOfStockBtn.removeClass("d-none");
            } else {
                $addToCartBtn.removeClass("d-none");
                $outOfStockBtn.addClass("d-none");
                $(".personalization-link-wrapper").removeAttr("disabled");
            }

            if (productName) {
                $productName
                    .html(productName);
            }

            if (primaryImageUrls && updateImgCarousel) {
                var $carousel = response.container.find(".pdp-carousel");
                var carouselOptions = {
                    infinite: false,
                    mobileFirst: true,
                    slidesToShow: 1,
                    speed: 500,
                    centerMode: false,
                    fade: true,
                    cssEase: "linear",
                    autoplay: false,
                    autoplaySpeed: $carousel.data("speed") || 3000,
                    pauseOnHover: false,
                    dots: $carousel.data("dots")
                };
                slickCarousel.default.create(currentProduct.images, response.container, carouselOptions);
            }
        });
    },
    updateAddToCart: function () {
        $("body").on("product:updateAddToCart", function (e, response) {
            // update local add to cart (for sets)
            $("button.add-to-cart", response.$productContainer).attr("disabled",
                (!response.product.readyToOrder || !response.product.available));

            var enable = $(".product-availability").toArray().every(function (item) {
                return $(item).data("available") && $(item).data("ready-to-order");
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $("body").on("product:updateAvailability", function (e, response) {
            $("div.availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available);

            $(".availability-msg", response.$productContainer)
                .empty().html(response.message);

            if ($(".global-availability").length) {
                var allAvailable = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("available"); });

                var allReady = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("ready-to-order"); });

                $(".global-availability")
                    .data("ready-to-order", allReady)
                    .data("available", allAvailable);

                $(".global-availability .availability-msg").empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
            packagingPDP();
        });
    },
    sizeChart: function () {
        $(".size-chart a").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr("href");
            var $prodSizeChart = $(this).closest(".size-chart").find(".size-chart-collapsible");
            if ($prodSizeChart.is(":empty")) {
                $.ajax({
                    url: url,
                    type: "get",
                    dataType: "json",
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass("active");
        });

        var $sizeChart = $(".size-chart-collapsible");
        $("body").on("click touchstart", function (e) {
            if ($(".size-chart").has(e.target).length <= 0) {
                $sizeChart.removeClass("active");
            }
        });
    },
    copyProductLink: function () {
        $("body").on("click", "#fa-link", function () {
            event.preventDefault();
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($("#shareUrl").val()).select();
            document.execCommand("copy");
            $temp.remove();
            $(".copy-link-message").attr("role", "alert");
            $(".copy-link-message").removeClass("d-none");
            setTimeout(function () {
                $(".copy-link-message").addClass("d-none");
            }, 3000);
        });
    },

    ToggleReadmoreBtn: function () {
        $(".read-more").on("click", function () {
            $(this).parent().toggleClass("ToggledContent");
            var changeText;
            if ($(this).parent().hasClass("ToggledContent")) {
                changeText = $(".readlesstext").text();
            }
            else {
                changeText = $(".readmoretext").text();
            }
            $(this).text(changeText);

        });
    },

    scrollToInterestForm: function () {
        $(".register-your-interest-scroll").length && preloadImages();

        $(document).on("click", ".register-your-interest-scroll", function () {
            $("html, body").animate({
                "scrollTop": $(".pdp-interest-form-container").offset().top
            }, 700, function () {
                $("#register-interest-email").focus();
            });
        });
    },

    /**
     * @description Shows the notify me form
     */
    showNotifyMeForm: function () {
        $body.on("click", ".js-show-notify-me-form", function () {
            $(".js-show-notify-me-form").first().addClass("d-none");
            $(".js-notify-me-form").removeClass("d-none");
        });
    },

    /**
     * @description Scroll the notify me form into view
     */
    scrollToNotifyMeForm: function () {
        $body.on("click", ".product-detail-sticky .js-show-notify-me-form", function () {
            const $pdpInterestForm = $(".pdp-interest-form-container");
            const $headerBanner = $(".header-content .container-wrapper");
            const headerHeight =  ($headerBanner.length ? $headerBanner.outerHeight() : 0) + $(".page-header").outerHeight();
            $("html, body").animate({
                "scrollTop": $pdpInterestForm.offset().top + parseInt($pdpInterestForm.css("margin-top"), 10) - headerHeight
            }, 500);
        });
    },

    submitInterestForm: function () {
        formReset();

        $(".submit-register-interest, .submit-notify-me").on("click", function (e) {
            e.preventDefault();

            $.spinner().start();
            const $button = $(this);
            const $form = $button.closest("form");
            const $privacyCheckbox = $form.find("#register-interest-accept-privacy-cookies");
            $button.addClass("disabled");
            const $serverErrorField = $(".notify-me-server-error, .register-interest-server-error");
            $serverErrorField.empty();

            recaptcha.setToken({ formSelector: $form })
                .then(() => setCSRFToken({ $form: $form }))
                .then(() => {
                    $.ajax({
                        url: $button.data("href"),
                        type: "post",
                        dataType: "json",
                        data: $form.serialize(),
                        success: function (data) {
                            const $formGroup = $form.find(".form-group");
                            $.spinner().stop();

                            if (!data.success) {
                                formHelpers.loadFormErrors($form, data);
                                $formGroup.removeClass("is-valid");
                                $button.removeClass("disabled");
                            } else {
                                formHelpers.clearPreviousErrors($form);
                                $formGroup.addClass("is-valid");
                                $button.addClass("btn-success disabled").text(data.message);
                                $privacyCheckbox.attr("disabled", true);
                                $("body").trigger("cbtOutOfStockNotification", data.cbtResponse);
                            }
                        },
                        error: function (err) {
                            $.spinner().stop();
                            $button.removeAttr("disabled");
                            const response = err.responseJSON;
                            if (response.csrfError) {
                                window.location.href = response.redirectUrl;
                            }
                            const message = response.message;
                            if (message) {
                                $serverErrorField.append("<p>" + message + "</p>");
                            }
                        }
                    });
                });
        });
    },

    quantityDropdownDisplay: function () {
        const $quantityDropdownModal = $("#quantity-dropdown-modal");
        const $quantitySelector = $(".quantity-select");
        const $quantityDropdownParent = $quantityDropdownModal.find(".modal-body");
        const $window = $(window);
        const observer = new MutationObserver(function (mutationList) {
            for (const mutation of mutationList) {
                mutation.removedNodes.forEach(function (removed_node) {
                    if ($(removed_node).hasClass("select2-container") && $quantityDropdownModal.hasClass("show")) {
                        $quantitySelector.select2("open");
                    }
                });
            }
        });

        if ($quantityDropdownModal.length && $quantitySelector.length) {
            let refreshQuantityDropdown = false;

            $document.ready(function () {
                $quantitySelector.select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $window.width() <= 768 ? $quantityDropdownParent : ""
                });
            });

            $quantitySelector.on("select2:opening", function () {
                if ($window.width() <= 768) {
                    $quantityDropdownModal.modal("show");
                }
            });

            $quantitySelector.on("select2:closing", function (e) {
                if ($quantityDropdownModal.hasClass("show")) {
                    e.preventDefault();
                }
            });

            $quantitySelector.on("select2:select", function () {
                if ($window.width() <= 768 && $quantityDropdownModal.hasClass("show")) {
                    $quantityDropdownModal.modal("hide");
                }
            });

            $quantityDropdownModal.on("hidden.bs.modal", function () {
                observer.disconnect();
                $quantitySelector.select2("close");
            });

            $quantityDropdownModal.on("show.bs.modal", function () {
                observer.observe($quantityDropdownParent[0], config);
            });

            $window.on("resize", debounce(function () {
                $quantitySelector.select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $window.width() <= 768 ? $quantityDropdownParent : ""
                });
            }, 200));

            $quantitySelector.on("select2:set.refresh", function() {
                refreshQuantityDropdown = true;
            });

            $quantitySelector.on("select2:refresh", function() {
                if (refreshQuantityDropdown) {
                    $quantitySelector.trigger("change");
                    refreshQuantityDropdown = false;
                }
            });
        }
    },

    formatDropdownDisplay: function () {
        const $formatDropdownModal = $("#format-dropdown-modal");
        const $formatSelector = $(".custom-select-format");
        const $formatDropdownParent = $formatDropdownModal.find(".modal-body");
        const $window = $(window);
        const observer = new MutationObserver(function (mutationList) {
            for (const mutation of mutationList) {
                mutation.removedNodes.forEach(function (removed_node) {
                    if ($(removed_node).hasClass("select2-container") && $formatDropdownModal.hasClass("show")) {
                        $formatSelector.select2("open");
                    }
                });
            }
        });

        if ($formatDropdownModal.length && $formatSelector.length) {
            $document.ready(function () {
                $formatSelector.select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $window.width() <= 768 ? $formatDropdownParent : ""
                });
            });

            $formatSelector.on("select2:opening", function () {
                if ($window.width() <= 768) {
                    $formatDropdownModal.modal("show");
                }
            });

            $formatSelector.on("select2:closing", function (e) {
                if ($formatDropdownModal.hasClass("show")) {
                    e.preventDefault();
                }
            });

            $formatSelector.on("select2:select", function () {
                if ($window.width() <= 768 && $formatDropdownModal.hasClass("show")) {
                    $formatDropdownModal.modal("hide");
                }
            });

            $formatDropdownModal.on("hidden.bs.modal", function () {
                observer.disconnect();
                $formatSelector.select2("close");
            });

            $formatDropdownModal.on("show.bs.modal", function () {
                observer.observe($formatDropdownParent[0], config);
            });

            $window.on("resize", debounce(function () {
                $formatSelector.select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $window.width() <= 768 ? $formatDropdownParent : ""
                });
            }, 200));
        }
    },

    packagingDropdownDisplay: function () {
        const $packagingDropdownModal = $("#packaging-dropdown-modal");
        const $packagingSelector = $(".custom-select-packaging");
        const $packagingDropdownParent = $packagingDropdownModal.find(".modal-body");
        const $window = $(window);
        function custom_template(obj) {
            var data = $(obj.element).data();
            var text = $(obj.element).html();
            var template;
            if (data && data["packaging"]) {
                var packaging = data["packaging"];
                template = $("<div><div class='d-flex justify-content-between'><span>"+text+"</span><span>"+packaging+"</span></div></div>");
                return template;
            } else {
                template = $("<div class='d-flex justify-content-between'><span>"+text+"</span></div>");
                return template;
            }
        }

        const observer = new MutationObserver(function (mutationList) {
            for (const mutation of mutationList) {
                mutation.removedNodes.forEach(function (removed_node) {
                    if ($(removed_node).hasClass("select2-container") && $packagingDropdownModal.hasClass("show")) {
                        $packagingSelector.select2("open");
                    }
                });
            }
        });

        if ($packagingDropdownModal.length && $packagingSelector.length) {

            $packagingSelector.select2({
                minimumResultsForSearch: -1,
                dropdownParent: $window.width() <= 768 ? $packagingDropdownParent : "",
                "templateSelection": custom_template,
                "templateResult": custom_template
            });

            $packagingSelector.on("select2:opening", function () {
                if ($window.width() <= 768) {
                    $packagingDropdownModal.modal("show");
                }
            });
            $packagingSelector.on("select2:closing", function (e) {
                if ($packagingDropdownModal.hasClass("show")) {
                    e.preventDefault();
                }
            });

            $packagingSelector.on("select2:select", function () {
                if ($window.width() <= 768 && $packagingDropdownModal.hasClass("show")) {
                    $packagingDropdownModal.modal("hide");
                }
            });

            $packagingDropdownModal.on("hidden.bs.modal", function () {
                observer.disconnect();
                $packagingSelector.select2("close");
            });

            $packagingDropdownModal.on("show.bs.modal", function () {
                observer.observe($packagingDropdownParent[0], config);
            });

            $window.on("resize", debounce(function () {

                $packagingSelector.select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $window.width() <= 768 ? $packagingDropdownParent : "",
                    "templateSelection": custom_template,
                    "templateResult": custom_template
                });

            }, 200));
        }
    },

    productTabsNavClass: function () {
        $("a[data-toggle='tab']").on("click", function() {
            var $this = $(this);
            $this.closest(".nav").find(".active").removeClass("active");
            $this.closest("li").addClass("active");
        });
    },

    productDetailSticky: function () {
        var $window = $(window);
        var $productDetailSticky = $(".product-detail-sticky");
        if ($productDetailSticky.length === 0) {
            return;
        }
        var $addToCart = $(".prices-add-to-cart-actions .btn");
        var $notifymeBtn = $(".submit-notify-me");
        var notifyMe = $notifymeBtn.length ? $notifymeBtn.isInViewport() : false;
        var $addToCartBtnIsBundle = $addToCart.attr("data-product-is-bundle");
        var $footer = $("footer");
        var position = $window.scrollTop();
        var addToCartButtonHidden = false;

        $addToCart.each(function () {
            if ($(this).hasClass("d-none")) {
                addToCartButtonHidden = false;
                return true;
            } else {
                addToCartButtonHidden = true;
                return false;
            }
        });
        if (addToCartButtonHidden) {
            $window.on("scroll", function () {
                var scroll = $window.scrollTop();
                var isSticky = scroll > position;

                updateBottomBackToTop($productDetailSticky, isSticky);

                if ($addToCart.isInViewport() || $footer.isInViewport() || notifyMe) {
                    $productDetailSticky.removeClass("m-stick");
                    setTabIndex($productDetailSticky, -1);
                } else {
                    if (isSticky) {
                        var $stickyCTABtn = $(".js-add-to-cart-copy");
                        var $mainCTABtn = $(".js-add-to-cart-main");
                        if ($addToCartBtnIsBundle) {
                            $stickyCTABtn.html($mainCTABtn.html());
                            $productDetailSticky.addClass("m-stick");
                            setTabIndex($productDetailSticky, 0);
                        } else {
                            if (!$productDetailSticky.hasClass("add-to-cart-copy-attached")) {
                                $stickyCTABtn.html($mainCTABtn.html());
                            }
                            var notifyMeButton = $productDetailSticky.find(".js-show-notify-me-form");
                            if (notifyMeButton.length) {
                                notifyMeButton.removeClass("d-none");
                            }
                            $productDetailSticky.addClass("m-stick add-to-cart-copy-attached");
                            setTabIndex($productDetailSticky, 0);
                        }
                    } else {
                        $productDetailSticky.removeClass("m-stick");
                        setTabIndex($productDetailSticky, -1);
                    }
                }
                position = scroll;
            });
        }
    },

    checkKeyboardUser: function() {
        $(document).on("keydown", function (event) {
            // keyboard navigation keys
            if (event.keyCode === 9 || event.keyCode === 32 || event.keyCode === 38 || event.keyCode === 40 || event.keyCode === 37 || event.keyCode === 39) {
                isKeyboardUser = true;
            }
        });

        $(document).on("mousemove wheel touchstart", function () {
            isKeyboardUser = false; // user switched to mouse/touch
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};
